import { useStyles, Flex, Caption } from '@archipro-design/aria';
import type { ArticleCarouselMobileProps } from '../../type';
import * as S from './ArticleList.style';
import { Link } from '@remix-run/react';
import ArchizeenTile from '~/modules/tile/component/archizeen-tile/ArchizeenImpressionTile';
import { useLocalisation } from '@archipro-website/localisation';
import { getFormattedLocalisedDate } from '@modules/date-time/util/get-localised-date';
import { useTracker } from '@archipro-website/tracker';
const ArticlesList: React.FC<ArticleCarouselMobileProps> = ({
    articleTiles,
    title,
    articleType,
}) => {
    const { css } = useStyles();
    const { localiseDate } = useLocalisation();
    const tracker = useTracker();
    return (
        <div className={css(S.Wrap)}>
            <Caption className={css(S.TitleWrap)} variant="02" weight="medium">
                {title}
            </Caption>
            <Flex column className={css(S.TileSlideWrap)}>
                {articleTiles.map((article) => {
                    const {
                        link,
                        ID,
                        professionalID,
                        title: articleTitle,
                        image: _,
                        canEdit: _canEdit,
                        bmEditorLink: _bmEditorLink,
                        date,
                        ...rest
                    } = article;
                    return (
                        <div className={css(S.TileSlide)} key={ID}>
                            <ArchizeenTile
                                key={ID}
                                as={Link}
                                to={link}
                                date={getFormattedLocalisedDate(
                                    localiseDate,
                                    date
                                )}
                                prefetch="intent"
                                {...rest}
                                variant="04"
                                size={'small'}
                                favouritePosition="card"
                                title={{
                                    children: articleTitle,
                                    maximumLines: 3,
                                }}
                                onClick={() => {
                                    tracker.log(`Article${articleType}Click`, {
                                        url: new URL(window.location.href),
                                        targetTracker: 'archiproTracker',
                                        data: {
                                            ExtraData: article.ID,
                                        },
                                    });
                                }}
                                impression={{
                                    professionalID: professionalID,
                                    itemID: ID,
                                    type: articleType,
                                }}
                                image={{
                                    width: 118,
                                    height: 131,
                                    src: article.image,
                                    alt: articleTitle,
                                }}
                                articleId={ID}
                            />
                        </div>
                    );
                })}
            </Flex>
        </div>
    );
};
export default ArticlesList;
